import { translate } from "@ollie-sports/i18n";
import { GENDERS } from "@ollie-sports/models";

export const prettyGender = (gender: GENDERS) => {
  if (gender === GENDERS.boys) return translate.common.Boys;
  if (gender === GENDERS.girls) return translate.common.Girls;

  return translate.common.Mixed;
};
